module.exports = __webpack_public_path__ + "static/build4u-4d0668c11781f3ef25342b2e9293140a.jpg";